import { render, staticRenderFns } from "./SettingsUpdateTranslationTags.vue?vue&type=template&id=36954645&scoped=true"
import script from "./SettingsUpdateTranslationTags.vue?vue&type=script&lang=js"
export * from "./SettingsUpdateTranslationTags.vue?vue&type=script&lang=js"
import style0 from "./SettingsUpdateTranslationTags.vue?vue&type=style&index=0&id=36954645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36954645",
  null
  
)

export default component.exports